<template>
    <div class="jgile-repeater">
        <div class="repeater-controls"></div>
        <div class="repeater-repating">
            <div class="repeater-repeated" v-for="(item, key) in value">
                <slot :item="item" :item-key="key"></slot>
                <div class="repeater-repeated-controls d-flex align-items-center">
                    <div class="d-flex flex-column">
                        <button class="btn btn-default btn-sm my-1" @click="remove(key)" v-if="canRemove">
                            <i class="fal fa-minus"></i>
                            <span class="sr-only">Remove Item</span>
                        </button>
                        <button class="btn btn-primary btn-sm" @click="add(key)" v-if="canAdd">
                            <i class="fal fa-plus"></i>
                            <span class="sr-only">Add Item</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Array, Object],
            required: true,
        },
        template: {
            default: null,
        },
        min: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: null,
        },
        indexes: {
            type: Boolean,
            default: false,
        },
        uuids: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        count() {
            return Array.isArray(this.value) ? this.value.length : Object.keys(this.value).length;
        },
        canAdd() {
            return this.max === null || this.count < this.max;
        },
        canRemove() {
            return this.count > this.min;
        },
    },
    created() {
        if (this.count < this.min) {
            this.emit([this.getTemplate()]);
        }
    },
    methods: {
        getTemplate(key) {
            if (this.canAdd) {
                if (this.template) {
                    return _.cloneDeep(this.template);
                }

                return _.cloneDeep(_.get(this.value, key, {}));
            }
        },
        remove(key) {
            if (this.canRemove) {
                this.emit(
                    _.filter(this.value, (item, itemKey) => {
                        return key !== itemKey;
                    }),
                );
            }
        },
        add(key) {
            if (this.canAdd) {
                let val = _.clone(this.value),
                    template = this.getTemplate(key);

                if (this.uuids) {
                    val[this.uuid()] = template;
                } else if (_.isObject(val) || self.indexes) {
                    val = _.values(val);
                    val.push(template);
                } else {
                    val.push(template);
                }

                this.emit(val);
            }
        },
        emit(val) {
            if (this.uuids) {
                val = _.mapKeys(val, (item, itemKey) => {
                    return self.isUuid(itemKey) ? itemKey : self.uuid();
                });
            } else if (_.isObject(val) || this.indexes) {
                val = _.mapKeys(val, (item, itemKey) => {
                    return _.toInteger(itemKey) + 1;
                });
            }

            this.$emit('input', val);
        },
        isUuid(a) {
            return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(a);
        },
        uuid(a, b) {
            for (b = a = ''; a++ < 36; b += (a * 51) & 52 ? (a ^ 15 ? 8 ^ (Math.random() * (a ^ 20 ? 16 : 4)) : 4).toString(16) : '-');
            return b;
        },
    },
};
</script>

<style lang="scss">
.jgile-repeater {
    .repeater-repeated {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 15px 0;

        .repeater-repeated-controls {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
        }
    }

    .repeater-repeated:last-child {
        border-bottom: none;
    }
}
</style>
